module.exports = __webpack_public_path__ + "static/colgadas-004.thumb-6c243f0696cb02850548754954b13836.jpg";